export default [{
	titulo: 'Auxílio Brasil',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/auxilio-brasil',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]